import React from 'react';

// helpers
import { StateModel } from '../../redux/reducers';
import { useSelector } from 'react-redux';

// components
import PageContentCard from 'modules/Layouts/MainLayout/PageRenderer/PageContentCard';
import ManageCircleService from '../../modules/ExternalServices/Circle/ManageCircleSection';

const ExternalServices = () => {
  const isTwoFactorVerificationEnabled = useSelector<StateModel, boolean>(
    (state) => state.auth.isTwoFactorVerificationEnabled,
  );

  return (
    <PageContentCard>
      <ManageCircleService disabled={!isTwoFactorVerificationEnabled} />
    </PageContentCard>
  );
};

export default ExternalServices;
